/**
 * Whether the account's Google (GMB) connection is valid, from the social-connections API response
 * (`GET /business-settings/:user_id/social-connections`).
 *
 * The backend decides: `is_gmb_connected` is true only when a google record holds both a refresh token and a GMB
 * location id. Until every backend serves the flag, fall back to the previous rule (a google record with a refresh
 * token) so the card does not turn to Connect for everyone during a rollout.
 *
 * @param {{ data?: Array<object>, is_gmb_connected?: boolean } | null | undefined} response
 * @returns {boolean}
 */
export const resolveIsGmbConnected = (response) => {
  if (!response) {
    return false
  }
  if (typeof response.is_gmb_connected === 'boolean') {
    return response.is_gmb_connected
  }
  const connections = Array.isArray(response.data) ? response.data : []
  return connections.some(
    (item) =>
      Boolean(item) && item.type === 'google' && Boolean(item.social_data) && Boolean(item.social_data.refresh_token)
  )
}

/**
 * Whether the account's Facebook connection is valid, from the same social-connections API response.
 *
 * The backend decides: `is_fb_connected` is true only when a facebook record (or the account's facebook link) holds
 * both a page id and a page access token. Until every backend serves the flag, fall back to the previous rule (any
 * facebook record).
 *
 * @param {{ data?: Array<object>, is_fb_connected?: boolean } | null | undefined} response
 * @returns {boolean}
 */
export const resolveIsFbConnected = (response) => {
  if (!response) {
    return false
  }
  if (typeof response.is_fb_connected === 'boolean') {
    return response.is_fb_connected
  }
  const connections = Array.isArray(response.data) ? response.data : []
  return connections.some((item) => Boolean(item) && item.type === 'facebook')
}
